<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.2041 5H31.7041V35H9.2041V5ZM12.9541 10.625H27.9541V12.5H12.9541V10.625ZM27.9541 14.375H12.9541V16.25H27.9541V14.375ZM12.9541 18.125H27.9541V20H12.9541V18.125ZM20.4541 23.75H12.9541V25.625H20.4541V23.75Z"
      class="fill-current"
    />
  </svg>
</template>
